export default __webpack_public_path__ + "static/media/default-product-img.732b7b1e.svg";